const SELECT_EVENT = 'underlyingSelect';

class UnderlyingSelect {
	constructor({ el, preselected } = {}) {
		this.el = el;
		this.preselected = preselected;

		this.el.addEventListener('change', e => this.onUnderylingChanged(e));
	}

	get selectedUnderlying() {
		const selectedKey = this.el.value;

		return this.underlyings.find(ul => ul.key === parseInt(selectedKey, 10)) || {};
	}

	async init(apiUrl) {
		const { assetClasses } = await UnderlyingSelect.fetchApiResponse(apiUrl);

		this.setUnderlyings(assetClasses);

		this.render(assetClasses);
	}

	select(underlyingKey) {
		this.el.value = underlyingKey;
	}

	onUnderylingChanged() {
		const { el: { value } } = this;
		const underlying = this.underlyings.find(i => i.key === parseInt(value, 10));

		const event = new CustomEvent(SELECT_EVENT, {
			bubbles: true,
			detail: underlying,
		});

		this.el.dispatchEvent(event);
	}

	render(assetClasses) {
		const groups = assetClasses
			.map(({ title, underlyings }) => UnderlyingSelect.createGroup(title, underlyings))
			.join('\n');

		this.el.insertAdjacentHTML('beforeend', groups);
	}

	update(assetClasses = []) {
		this.setUnderlyings(assetClasses);

		const underlyingOptions = Array.from(this.el.querySelectorAll('option'));

		underlyingOptions
			.filter(option => option.value !== '')
			.forEach((option) => {
				const { isActive } = this.underlyings.find(u => u.key === parseInt(option.value, 10)) || {};

				option.disabled = !isActive;
			});
	}

	setUnderlyings(assetClasses) {
		this.underlyings = [].concat(...assetClasses.map(res => res.underlyings));
	}

	static createGroup(title, underlyings) {
		const options = underlyings
			.map(({ key, name, isActive }) => `<option ${isActive ? '' : 'disabled'} value="${key}">${name}</option>`)
			.join('\n');

		const group = `
			<optgroup label="${title}">
				${options}
			</optgroup>
		`;

		return group;
	}

	static async fetchApiResponse(url) {
		const res = await fetch(url);

		if (res.ok) {
			return res.json();
		}

		throw new Error(res.statusText);
	}
}

export default UnderlyingSelect;

export {
	SELECT_EVENT,
};
